import { render, staticRenderFns } from "./ShareCustomerGatewayFileForm.vue?vue&type=template&id=b46dad6e&"
import script from "./ShareCustomerGatewayFileForm.vue?vue&type=script&lang=js&"
export * from "./ShareCustomerGatewayFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports